import React, { useState } from "react"
import TemplateSelector from "./templateSelector"
import MinimalTemplate from "../Template/minimalTemplate"
import LuxuryTemplate from "../Template/luxuryTemplate"
import ModernTemplate from "../Template/modernTemplate"
import ClassicTemplate from "../Template/classicTemplate"
import VideoTemplate from "../Template/videoTemplate"
import SplitTemplate from "../Template/splitTemplate"
import useCartStore from "../../stores/useCartStore"

export default function CartScreen() {
  const [currentTemplate, setCurrentTemplate] = useState("video")
  const cart = useCartStore((s) => s.cart)

  const renderTemplate = () => {
    switch (currentTemplate) {
      case "minimal":
        return <MinimalTemplate cart={cart} />
      case "luxury":
        return <LuxuryTemplate cart={cart} />
      case "modern":
        return <ModernTemplate cart={cart} />
      case "classic":
        return <ClassicTemplate cart={cart} />
      case "video":
        return <VideoTemplate cart={cart} />
      case "split":
        return <SplitTemplate cart={cart} />
      default:
        return <MinimalTemplate cart={cart} />
    }
  }

  return (
    <div style={{ position: "relative" }}>
      <TemplateSelector
        currentTemplate={currentTemplate}
        onTemplateChange={setCurrentTemplate}
      />
      {renderTemplate()}
    </div>
  )
}
